













































































































































































































































































import ICustomer from '@/store/models/ICustomer';
import IListPhonePrefix from '@/store/models/IListPhonePrefix';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CustomerAdressesSelector from '@/components/selectors/Customer/CustomerAdressesSelector.vue';
import CustomerContactsSelector from '@/components/selectors/Customer/CustomerContactsSelector.vue';
import IListCountries from '@/store/models/IListCountries';
import IListAdressTypes from '@/store/models/IListAdressTypes';
import ICompany from '@/store/models/ICompany';
import ICustomerAdresses from '@/store/models/ICustomerAdresses';
import ICustomerContacts from '@/store/models/ICustomerContacts';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRole from '@/store/models/IRole';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        CustomerAdressesSelector,
        CustomerContactsSelector,
        Snackbar
    }
})
export default class CustomerSelector extends Vue {
    searchCustomer: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;

    headers: any = [
        { text: 'Name', align: 'start', value: 'name' },
        { text: 'Fiscal Identifier', value: 'fiscalIdentifier' },
        { text: 'Prefix', value: 'prefix' },
        { text: 'Phone Number', value: 'phoneNumber' },
        { text: 'Country Name', value: 'countryName' },
        { text: 'Company Name', value: 'companyName' },
        { text: 'Require Inbounds Fields', value: 'requireInboundFields' },
        { text: 'QR Code on Pallet Label', value: 'palletQr' }
        // NeededPalletId y Actions se añaden en computedHeaders
    ];

    // Headers dinámicos
    get computedHeaders() {
        const base = [...this.headers];
        if (this.HasLicenseScanner) {
            base.push({ text: 'Needed Pallet ID', value: 'neededPalletId' });
        }
        base.push({ text: 'Actions', value: 'actions', sortable: false });
        return base;
    }

    editedIndex: number = -1;

    editedItem: ICustomer = {
        id: "",
        name: "",
        fiscalIdentifier: "",
        idListPhonePrefix: "",
        prefix: "",
        phoneNumber: "",
        idCompany: "",
        companyName: "",
        idUser: "",
        userName: "",
        password: "",
        idRole: "",
        roleName: "",
        requireInboundFields: false,
        palletQr: false,
        neededPalletId: false,
        idListCountry: "",
        countryName: ""
    };

    defaultItem: ICustomer = {
        id: "",
        name: "",
        fiscalIdentifier: "",
        idListPhonePrefix: "",
        prefix: "",
        phoneNumber: "",
        idCompany: "",
        companyName: "",
        idUser: "",
        userName: "",
        password: "",
        idRole: "",
        roleName: "",
        requireInboundFields: false,
        palletQr: false,
        neededPalletId: false,
        idListCountry: "",
        countryName: ""
    };

    @Prop({ type: Array, required: true })
    CustomerList!: ICustomer[];
    @Prop({ type: Array, required: true })
    ListPhonePrefix!: IListPhonePrefix[];
    @Prop({ type: Array, required: true })
    ListCountries!: IListCountries[];
    @Prop({ type: Array, required: true })
    ListAdressTypes!: IListAdressTypes[];
    @Prop({ type: Array, required: true })
    CustomerAdressesList!: ICustomerAdresses[];
    @Prop({ type: Array, required: true })
    CustomerContactsList!: ICustomerContacts[];
    @Prop({ type: Array, required: true })
    ListCompany!: ICompany[];
    @Prop({ type: Array, required: true })
    ListRoles!: IRole[];
    @Prop()
    IdCompany!: string;
    @Prop({ type: Array, required: true })
    Permissions!: IRolePermission[];
    @Prop({ type: Boolean, required: true })
    HasLicenseScanner!: boolean;
    @Prop({ default: null })
    value!: ICustomer | null;

    selectedCustomer: ICustomer[] = [];
    selectedCustomerAdres: ICustomerAdresses[] = [];
    selectedCustomerContact: ICustomerContacts[] = [];
    selectedCountry: any = null;
    selectedPhonePrefix: any = null;
    selectedCompany: any = null;
    selectedRole: any = null;
    phonePrefixCountry: string[] = [];
    password: string = "";
    showPassword: boolean = false;

    get formTitle() {
        return this.editedIndex === -1 ? 'New Customer' : 'Edit Customer';
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    get ListPhonePrefixesSort() {
        return [...this.ListPhonePrefix].sort((a, b) => a.prefix.localeCompare(b.prefix));
    }

    @Watch('value')
    updateSelection(newValue: ICustomer | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedCustomer = [];
        } else {
            this.selectedCustomer = [newValue];
            this.$emit('customerChanged', this.selectedCustomer[0]);
        }
    }

    ResetCustomer() {
        this.selectedCountry = null;
        this.selectedPhonePrefix = null;
        this.selectedCompany = null;
        this.selectedRole = null;
        this.password = "";

        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;

        this.$emit('resetCustomer');
    }

    editCustomer(item: any) {
        if (!item) return;

        this.editedIndex = this.CustomerList.indexOf(item);
        this.editedItem = Object.assign({}, this.defaultItem, item);

        const idListPhonePrefix = this.editedItem.idListPhonePrefix || "";
        const idListCountry = this.editedItem.idListCountry || "";
        const idCompany = this.editedItem.idCompany || "";

        this.selectedPhonePrefix = idListPhonePrefix
            ? this.ListPhonePrefix.find(p =>
                (p.id || "").toLocaleLowerCase() === idListPhonePrefix.toLocaleLowerCase()
            )
            : null;

        this.selectedCountry = idListCountry
            ? this.ListCountries.find(c =>
                (c.id || "").toLocaleLowerCase() === idListCountry.toLocaleLowerCase()
            )
            : null;

        this.selectedCompany = idCompany
            ? this.ListCompany.find(p =>
                (p.id || "").toLocaleLowerCase() === idCompany.toLocaleLowerCase()
            )
            : null;

        this.selectedRole = this.ListRoles.find(r => r.roleName === this.editedItem.roleName) || null;

        this.password = "";
        this.dialog = true;
    }

    saveCustomer() {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.setCountry();
            this.setCountryPrefix();
            this.setCompany();

            if (this.editedIndex > -1) {
                this.$emit('editCustomer', this.editedItem);
                Object.assign(this.CustomerList[this.editedIndex], this.editedItem);
            } else {
                this.$emit('saveCustomer', this.editedItem);
            }

            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    setCountry() {
        if (this.selectedCountry && this.selectedCountry.id) {
            const country: IListCountries | undefined = this.ListCountries.find(
                c => c.id === this.selectedCountry.id
            );

            if (country) {
                this.editedItem.idListCountry = country.id;
                this.editedItem.countryName = country.countryName;
            }
        } else {
            this.editedItem.idListCountry = "";
            this.editedItem.countryName = "";
        }
    }

    deleteCustomer(customer: ICustomer) {
        if (this.selectedCustomer.length > 0) {
            this.$emit('deleteCustomer', customer);
            this.close();
        }
    }

    close(): void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
            this.selectedCountry = null;
            this.selectedPhonePrefix = null;
            this.selectedCompany = null;
            this.selectedRole = null;
        });
    }

    setCountryPrefix() {
        if (this.selectedPhonePrefix) {
            let phonePrefix: IListPhonePrefix = this.ListPhonePrefix.find(p => p.country === this.selectedPhonePrefix.country)!;
            if (phonePrefix) {
                this.editedItem.idListPhonePrefix = phonePrefix.id;
                this.editedItem.prefix = phonePrefix.prefix;
            }
        }
    }

    setCompany() {
        if (this.selectedCompany) {
            let company: ICompany = this.ListCompany.find(p => p.id === this.selectedCompany.id)!;
            if (company) {
                this.editedItem.idCompany = company.id;
                this.editedItem.companyName = company.name;
            }
        }
    }

    setRole() {
        if (this.selectedRole) {
            let role: IRole = this.ListRoles.find(p => p.id === this.selectedRole.id)!;
            if (role) {
                this.editedItem.idRole = role.id;
                this.editedItem.roleName = role.roleName;
            }
        }
    }

    select(item: ICustomer): void {
        let index: number = this.selectedCustomer.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedCustomer = [item];
            this.$emit('input', item);
        } else {
            this.selectedCustomer = [];
            this.$emit('input', null);
        }
    }

    saveCustomerAdress(item: any): void {
        this.$emit('saveCustomerAdress', item);
    }

    editCustomerAdress(item: any): void {
        this.$emit('editCustomerAdress', item);
    }

    deleteCustomerAdress(item: any): void {
        this.$emit('deleteCustomerAdress', item);
    }

    saveCustomerContact(item: any): void {
        this.$emit('saveCustomerContact', item);
    }

    editCustomerContact(item: any): void {
        this.$emit('editCustomerContact', item);
    }

    deleteCustomerContact(item: any): void {
        this.$emit('deleteCustomerContact', item);
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }

    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
